import { defineStore } from 'pinia';

interface WalletState {
  amount: string;
}

export const useWalletStore = defineStore('wallet', {
  state: (): WalletState => ({
    amount: '',
  }),
  getters: {
    record(state) {
      return {
        amount: state.amount,
      };
    },
  },
  actions: {
    saveRecord(payload: Partial<WalletState>) {
      this.amount = payload.amount ?? this.amount;
    },
    clearRecord() {
      this.amount = '';
    },
  },
  persist: true,
});
